import { colors } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Section from './components/Section'

interface ComplementaryHoursProps {
  complementaryHourMinutes: number
}

const ComplementaryHours = ({ complementaryHourMinutes }: ComplementaryHoursProps) => {
  return (
    <Section
      title={i18n.t('clock_in.sidepanel.accordion.complementary_hours.title')}
      minutes={complementaryHourMinutes}
      circleColor={colors.malibu1000}
    />
  )
}

export default ComplementaryHours
